import {
	type HeadingField,
	type RowField,
} from '../../../types/graphql.form.ts'

export default function Heading({
	field,
	className = '',
}: {
	field: RowField
	className?: string
}) {
	const heading = field as HeadingField
	const Size = heading.headingSize || 'h2'

	return <Size className={`${className} full`}>{heading.name}</Size>
}
